import './VtxSteps.scss';
import React, { FunctionComponent } from 'react';
import { Steps } from 'antd';
import { StepsProps, StepProps } from 'antd/lib/steps';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';

export interface VtxStepsProps extends StepsProps, IAutomatable {}
export interface VtxStepProps extends StepProps, IAutomatable {}

export const VtxSteps: FunctionComponent<VtxStepsProps> = React.memo((props: VtxStepsProps) => {
    const automationClass = 'vtx-steps';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass, className);

    return (
        <div data-automation-class={automationClass} className={classNamesCombined}>
            <Steps {...otherProps}></Steps>
        </div>
    );
});

export const VtxStep: FunctionComponent<VtxStepProps> = React.memo((props: VtxStepProps) => {
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(className);

    return <Steps.Step className={classNamesCombined} {...otherProps}></Steps.Step>;
});
